// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NrPYt","col":"styles_col__1KzGK"};